import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { AttachmentChannelPicker } from "./AttachmentChannelPicker";

/** "Enviado também por" no detalhe do pedido — editável dos dois lados (clínica ou laboratório,
 *  ver prosthesis.setSentChannels). Sempre visível, independente de ter anexo: o pedido às vezes
 *  nem chega a ser enviado pelo SaaS de fato, isso registra por onde foi combinado de verdade.
 *  `readOnly` (ex: resumo do Início) troca o seletor por uma lista estática, sem mutation. */
export function SentChannelsField({
  orderId,
  sentChannels,
  readOnly = false,
}: {
  orderId: string;
  sentChannels: string[];
  readOnly?: boolean;
}) {
  const utils = trpc.useUtils();

  const setSentChannels = trpc.prosthesis.setSentChannels.useMutation({
    onSuccess: () => {
      utils.prosthesis.getById.invalidate({ id: orderId });
      utils.prosthesis.incoming.getById.invalidate({ id: orderId });
    },
    onError: (err) => toast.error(err.message || "Erro ao atualizar."),
  });

  return (
    <div>
      <p className="mb-1.5 text-[11px] uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">
        Enviado também por
      </p>
      {readOnly ? (
        sentChannels.length > 0 ? (
          <div className="flex flex-wrap items-center gap-1.5">
            {sentChannels.map((channel) => (
              <span
                key={channel}
                className="inline-flex h-7 items-center rounded-full border border-brand-600 bg-brand-600 px-2.5 text-[11.5px] font-medium text-white"
              >
                {channel}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-sm text-zinc-400 dark:text-muted-foreground">Nenhum canal registrado.</p>
        )
      ) : (
        <AttachmentChannelPicker
          value={sentChannels}
          onChange={(channels) => setSentChannels.mutate({ orderId, sentChannels: channels })}
        />
      )}
    </div>
  );
}
